/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1EmployeepostId202,
  PutApiV1EmployeepostId400,
  PutApiV1EmployeepostId401,
  PutApiV1EmployeepostId404,
  PutApiV1EmployeepostId409,
  PutApiV1EmployeepostId500,
  PutApiV1EmployeepostIdMutationRequest,
  PutApiV1EmployeepostIdMutationResponse,
  PutApiV1EmployeepostIdPathParams,
} from "../../types/employeePostController/PutApiV1EmployeepostId.ts";
import { employeePostViewModelSchema } from "../employeePostViewModelSchema.ts";
import { updateEmployeePostRequestViewModelSchema } from "../updateEmployeePostRequestViewModelSchema.ts";

export const putApiV1EmployeepostIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1EmployeepostIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1EmployeepostId202Schema = z.lazy(
  () => employeePostViewModelSchema,
) as unknown as ToZod<PutApiV1EmployeepostId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1EmployeepostId400Schema =
  z.any() as unknown as ToZod<PutApiV1EmployeepostId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1EmployeepostId401Schema =
  z.any() as unknown as ToZod<PutApiV1EmployeepostId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1EmployeepostId404Schema =
  z.any() as unknown as ToZod<PutApiV1EmployeepostId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1EmployeepostId409Schema =
  z.any() as unknown as ToZod<PutApiV1EmployeepostId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1EmployeepostId500Schema =
  z.any() as unknown as ToZod<PutApiV1EmployeepostId500>;

export const putApiV1EmployeepostIdMutationRequestSchema = z.lazy(
  () => updateEmployeePostRequestViewModelSchema,
) as unknown as ToZod<PutApiV1EmployeepostIdMutationRequest>;

export const putApiV1EmployeepostIdMutationResponseSchema = z.lazy(
  () => putApiV1EmployeepostId202Schema,
) as unknown as ToZod<PutApiV1EmployeepostIdMutationResponse>;
